import {baseUrl, buildAuthRequest, buildQueryString, handleJsonResponse} from "./util/Common";

function telemetryExport(hubId, from, to) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/telemetry/export${buildQueryString({from, to})}`, req);
        });
}

export {
    telemetryExport
}